<template>
  <!-- TODO:CSSを共通処理に移動 -->
  <div class="error-background">
    <div class="error d-flex justify-content-center align-items-center">
      <InternalServerErrorContent />
    </div>
  </div>
</template>

<script>
import InternalServerErrorContent from "@/components/organisms/InternalServerErrorContent.vue"
/**
 * 500 INTERNAL SERVER ERROR 画面
 * ※コンポーネント名の先頭に数字は使用しない事
 */
export default {
  name: "InternalServerError",
  components: {
    InternalServerErrorContent,
  },
}
</script>

<style lang="scss" scoped>
.error-background {
  height: 100%;
  background: #e9e9e9;
}

.error {
  max-width: 550px;
  height: 100%;
  margin: auto;
}
</style>
